import { alpha } from '@mentimeter/ragnar-colors';
import { useRagnar } from '@mentimeter/ragnar-react';
import { CountdownClock as CountdownClockVisualization } from '@mentimeter/visualizations';
import { useEffect, useMemo, useRef } from 'react';

// Inner radius * 2
const LAYOUT = { width: 160 * 2, height: 160 * 2 };
const BASE_COLOR_ALPHA = 0.1;

export const CountdownClock = ({
  id,
  duration,
}: {
  id: string;
  duration: number;
}) => {
  const {
    theme: { visualizationColors },
  } = useRagnar();

  const selector = useMemo(() => {
    return `${id}-countdown`;
  }, [id]);

  const svgRef = useRef<CountdownClockVisualization | null>(null);

  useEffect(() => {
    if (svgRef.current) return;
    svgRef.current = new CountdownClockVisualization({
      backgroundColor: alpha(
        visualizationColors.fillColors[0] ?? visualizationColors.textColor,
        BASE_COLOR_ALPHA,
      ),
      fillColors: visualizationColors.fillColors, // Don't think this one needs more than one color?
      selector: `#${selector}`,
      layout: LAYOUT,
    });
    svgRef.current.buildClock();
    svgRef.current.start(duration);
  }, [
    duration,
    selector,
    visualizationColors.textColor,
    visualizationColors.fillColors,
  ]);

  const { width, height } = LAYOUT;

  return (
    <svg
      height="100%"
      width="100%"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMidYMid"
    >
      <g id={selector} />
    </svg>
  );
};
